import {$dom} from '../../../../helpers/dom';
import {isElement} from '../../../../helpers/_utilities';
import gsap from 'gsap';

const {
	exist,
	get
} = $dom;

export default function setCatalogShowMoreMinHeight() {
	const
		targetSelector = '.js-catalog-show-more',
		cardSelector = '.card__product'
	;

	if (exist([targetSelector, cardSelector])) {
		const firstCard = get(cardSelector);
		if (isElement(firstCard)) {
			gsap.set(targetSelector, {clearProps: 'minHeight'});
			gsap.set(targetSelector, {minHeight: firstCard.offsetHeight});
		}
	}
}
